export default __webpack_public_path__ + "static/website-video-15a26b2b5cf5d02a7b4addd0bf59caf9.mp4";